<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
    <div>
      <div class="d-flex whitesmoke">
        <v-subheader class="justify-space-between subtitle-1 whitesmoke font-weight-medium grayBold--text">
          {{ $t("devices_info") }}
        </v-subheader>
      </div>
      <v-data-table :headers="tableheaders" :items="devices"
        @click:row="selectDevice"
        fixed-header max-height="450px" item-key="tagId" class="installation-table max-height elevation-1"
         :loading-text="$t('loadingData')">
        <template v-slot:[`item.type`]="{ item }">
          <v-icon v-if="item.type">
            {{getIconFromDeviceType(item.type)}}
          </v-icon>
        </template>
        <template v-slot:no-data>
          {{ $t("devicesEmpty") }}
        </template>
        <!-- does not use deviceInfo, but it needs to be attached to a value in devices, loggedIn is already used -->
        <template v-slot:[`item.id`]="{ item }">
          <Dropdown>
            <DropdownItem title="view" @clicked="selectDevice(item)" />
            <DropdownItem title="edit" @clicked="editInstallation(item)" />
            <DropdownItem title="delete" @clicked="deleteInstallation(item)" />
          </Dropdown>
        </template>
      </v-data-table>
    </div>
  </template>
  
  <script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
  import { commonModule, installationsModule, devicesModule } from '@/store/modules/store-accessor'
  import { TimeUtil } from '@/helpers/TimeUtil'
  import Dropdown from '../../../components/dropdown/Dropdown.vue'
  import DropdownItem from '../../../components/dropdown/DropdownItem.vue'
  import { getIconFromDeviceType, sortTableDates } from "@/helpers/data";

  @Component({
    components: { Dropdown, DropdownItem }
  })
  export default class InstallationsSideviewDevicesTab extends Vue {
    @Prop() installation: Record<string, any>;

    tableheaders: any [] = [
      { text: this.$t("type"), align: 'left', sortable: false, class: 'row-style', value: 'type', width: '10px' },
      { text: this.$t("brand"), align: 'left', class: 'row-style', sortable: true, value: 'make_model'},
      { text: this.$t("serial_number"), align: 'left', class: 'row-style', sortable: true, value: 'serial_no', width: '170px' },
      { text: this.$t("device_id"), align: 'left', class: 'row-style', sortable: true, value: 'device_id'},
      { text: this.$t("device_friendly_name"), align: 'left', class: 'row-style', sortable: true, value: 'device_name'},
    ]
  
    expandedItems: any[] = [];
  
    mounted() {
      installationsModule.getInstallationDevices(this.installation.info.id)
    }

    formatDate (date: Date): string {
      return TimeUtil.formatDateTime(date)
    }

    getIconFromDeviceType(deviceType: string) {
      return getIconFromDeviceType(deviceType);
    }
  
    get devices () {
      return installationsModule.currentInstallationDevices
    }

    async selectDevice (device: any) {
      await devicesModule.getDeviceInfo(device.device_id);
      commonModule.showSideview({ name: 'devices-sideview' , payload: { deviceId: device.device_id, installationId: this.installation.info.id } })
    }

  };
  </script>
  
  <style scoped lang="scss">
  .tab {
    // max-height: calc(100vh) !important;
    overflow-y: auto;
  }
  
  div { 
      width:100%;
  }
  
  .expansion{
    color: whitesmoke;
  }
  
  .expansion-item {
    display: block;
    width: 50px;
    word-wrap: break-word;
  }
  
  .wrap {
    width: 20px;
    word-wrap: break-word;
  }
  
  .spanWordWrap {
    display: block;
    width: 200px;
    word-wrap: break-word;
  }
  
  .cost {
    min-width: 30px;
    text-align: right;
  }
  
  .v-tooltip__content {
    background-color: white;
    color: black;
    font-size: 14px;
    margin-left: 10px;
    padding: 8px;
    font-family: Arial, sans-serif;
    border-style: solid;
    border-color: #777777;
    border-width: 1px;
  }
  
  /* v-menu width for dropdown */
  .v-menu__content {
    max-width: 240px!important;
  }
  
  .toggleUpDown {
      transition: transform .3s ease-in-out !important;  
  }
  
  .toggleUpDown.rotate {
      transform: rotate(-180deg);
  }
  
  .list_icon {
    width: 24px;
    height: 24px;
    margin-right: 8px !important;
  }
  
  .divider {
    margin-left: 47px;
    margin-right: 5px;
  }
  
  </style>
  